import { z } from 'zod';
import { appointmentStatusSchema, appointmentLabelSchema, tierSchema } from '@forcebase-ai/core';

// src/doctor.ts
var doctorMeSchema = z.object({
  id: z.string().uuid(),
  first_name: z.string(),
  last_name: z.string(),
  email: z.string(),
  specialty: z.string().nullable().optional()
});
var queueItemSchema = z.object({
  id: z.string().uuid(),
  patient_id: z.string().uuid(),
  scheduled_at: z.string(),
  duration_minutes: z.number(),
  label: appointmentLabelSchema,
  status: appointmentStatusSchema,
  emr_sync_status: z.string().nullable().optional(),
  zoom_sync_status: z.string().nullable().optional()
});
var doctorAppointmentSchema = z.object({
  id: z.string().uuid(),
  patient_id: z.string().uuid(),
  scheduled_at: z.string(),
  duration_minutes: z.number(),
  label: appointmentLabelSchema,
  status: appointmentStatusSchema,
  zoom_meeting_id: z.string().nullable().optional()
}).passthrough();
var rosterPatientSchema = z.object({
  id: z.string().uuid(),
  first_name: z.string(),
  last_name: z.string(),
  dob: z.string().nullable().optional(),
  tier: tierSchema,
  last_visit_at: z.string().nullable().optional()
});
var patientBriefSchema = z.object({
  patient: z.object({
    id: z.string().uuid(),
    first_name: z.string(),
    last_name: z.string(),
    dob: z.string().nullable().optional(),
    phone: z.string().nullable().optional(),
    email: z.string().nullable().optional(),
    insurance_carrier: z.string().nullable().optional(),
    insurance_member_ref: z.string().nullable().optional(),
    tier: tierSchema,
    healthie_patient_id: z.string().nullable().optional()
  }),
  visit_summaries: z.array(
    z.object({
      id: z.string().uuid(),
      last_visit_at: z.string(),
      summary_text: z.string(),
      healthie_appointment_id: z.string().nullable().optional()
    })
  )
});
var huddleNoteSchema = z.object({
  id: z.string().uuid(),
  body: z.string(),
  updated_at: z.string()
}).nullable();
var doctorChatMessageSchema = z.object({
  id: z.string().uuid(),
  sender_role: z.string(),
  body: z.string(),
  created_at: z.string()
});
var doctorChatThreadSchema = z.object({
  thread_id: z.string().uuid(),
  messages: z.array(doctorChatMessageSchema)
});
var hostJoinTicketSchema = z.object({
  meetingNumber: z.string(),
  startUrl: z.string().nullable().optional(),
  signature: z.string(),
  sdkKey: z.string().nullable().optional(),
  role: z.literal(1)
});
var healthieHandoffSchema = z.record(z.unknown());
var doctorAvailabilitySchema = z.object({
  weekly: z.array(
    z.object({
      id: z.string().uuid(),
      weekday: z.number(),
      starts_at: z.string(),
      ends_at: z.string(),
      timezone: z.string().nullable().optional()
    })
  ),
  exceptions: z.array(
    z.object({
      id: z.string().uuid(),
      starts_at: z.string(),
      ends_at: z.string(),
      kind: z.enum(["pto", "block", "extra"]),
      reason: z.string().nullable().optional()
    })
  )
});
var availabilitySlotsSchema = z.object({ slots: z.array(z.string()) });
var doctorProfileSchema = z.object({
  profile: z.object({
    id: z.string().uuid(),
    first_name: z.string(),
    last_name: z.string(),
    email: z.string(),
    specialty: z.string().nullable().optional()
  }).nullable(),
  credentials: z.object({
    npi: z.string(),
    dea_number: z.string().nullable().optional(),
    license_state: z.string(),
    license_number: z.string(),
    license_expires_at: z.string().nullable().optional(),
    malpractice_carrier: z.string().nullable().optional(),
    malpractice_policy_no: z.string().nullable().optional(),
    malpractice_expires_at: z.string().nullable().optional(),
    agreement_version: z.string().nullable().optional(),
    agreement_accepted_at: z.string().nullable().optional(),
    baa_accepted_at: z.string().nullable().optional()
  }).nullable()
});
var profileUpdateSchema = z.object({
  first_name: z.string().min(1),
  last_name: z.string().min(1),
  email: z.string().email(),
  specialty: z.string().nullish(),
  npi: z.string().min(1),
  license_state: z.string().min(1),
  license_number: z.string().min(1),
  license_expires_at: z.string().nullish(),
  dea_number: z.string().nullish(),
  malpractice_carrier: z.string().nullish(),
  malpractice_policy_no: z.string().nullish(),
  malpractice_expires_at: z.string().nullish()
});
var visitSummaryWriteSchema = z.object({
  last_visit_at: z.string(),
  summary_text: z.string().min(1).max(280),
  healthie_appointment_id: z.string().uuid()
});

export { availabilitySlotsSchema, doctorAppointmentSchema, doctorAvailabilitySchema, doctorChatMessageSchema, doctorChatThreadSchema, doctorMeSchema, doctorProfileSchema, healthieHandoffSchema, hostJoinTicketSchema, huddleNoteSchema, patientBriefSchema, profileUpdateSchema, queueItemSchema, rosterPatientSchema, visitSummaryWriteSchema };
//# sourceMappingURL=chunk-AUGHZVPD.js.map
//# sourceMappingURL=chunk-AUGHZVPD.js.map